function addWorldwideFooterLinksIfNotUK(isUkCombined) {
  window.orb = window.orb || {};
  const worldwideFooterLinksHtml = window.orb.worldwideFooterlinks;
  if (isUkCombined === false && worldwideFooterLinksHtml) {
    // add worldwide advertisement links to the footer
    document
      .querySelector('#orb-contentinfo ul')
      .insertAdjacentHTML('beforeend', worldwideFooterLinksHtml);
  }
}

window.bbcuser
  .isUKCombined()
  .then(addWorldwideFooterLinksIfNotUK)
  .catch(() => {
    // default to uk if promise fails
    addWorldwideFooterLinksIfNotUK(true);
  });

import('./orbit/font-watcher.js').then((fontWatchModule) => {
  const watch = fontWatchModule.default;
  Promise.all([
    window.bbcpage.isModal(),
    watch('ReithSans', 'b-reith-sans-loaded'),
  ]).then((results) => {
    // TODO remove when legacy orb goes away
    if (
      // if in legacy orbit
      window.require.defined &&
      window.require.defined('orb/features/masthead/_layoutprimarynav')
    ) {
      const hasHeader = !results[0];
      if (hasHeader) {
        window.require(['orb/features/masthead/_layoutprimarynav'], (layout) =>
          layout.recalculateLayout()
        );
      }
    }
  });

  if (document.documentElement.className.includes('b-reith-serif-font')) {
    watch('ReithSans', 'b-reith-serif-loaded');
  }
});
